import EnergyShieldBadge from './energy_shield_badge';
export default EnergyShieldBadge;
